import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function Method() {
  const steps = [{
    n: '01',
    title: 'Auditoría & estrategia',
    desc: 'Analizamos tu cuenta, tu oferta y tu competencia. Definimos públicos, ángulos y la estructura de campaña antes de gastar un solo euro.'
  }, {
    n: '02',
    title: 'Producción creativa',
    desc: 'Generamos los anuncios: copys, conceptos y formatos. Varias variantes para encontrar al ganador rápido.'
  }, {
    n: '03',
    title: 'Lanzamiento & testing',
    desc: 'Configuramos tracking, lanzamos y testeamos en frío. Recogemos datos reales para tomar decisiones, no corazonadas.'
  }, {
    n: '04',
    title: 'Optimización & escala',
    desc: 'Cortamos lo que no funciona, doblamos lo que sí. Escalamos manteniendo el coste por resultado bajo control.'
  }];
  const barsRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(barsRef, {
    once: true,
    margin: '-20%'
  });
  const [barsAnimated, setBarsAnimated] = useState(false);
  useEffect(() => {
    if (isInView && !barsAnimated) {
      setBarsAnimated(true);
    }
  }, [isInView, barsAnimated]);
  const barHeights = [30, 48, 38, 62, 55, 78, 70, 95];
  return <section className="relative py-[110px] border-t border-line" id="metodo" data-id="element-115">
      <div className="max-w-wrap mx-auto px-7" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1]
      }} className="flex items-end justify-between gap-[30px] mb-[64px] flex-wrap" data-id="element-117">
          <div data-id="element-118">
            <div className="font-mono text-[0.74rem] tracking-[0.16em] text-acid uppercase flex items-center gap-[10px] mb-5 before:content-[''] before:w-[28px] before:h-[1px] before:bg-acid" data-id="element-119">
              Cómo trabajamos
            </div>
            <h2 className="text-[clamp(2rem,4.6vw,3.5rem)] font-bold tracking-[-0.03em] leading-[1.02] max-w-[18ch]" data-id="element-120">
              Un método, no{' '}
              <span className="font-serif italic font-normal" data-id="element-121">
                improvisación.
              </span>
            </h2>
          </div>
          <p className="max-w-[38ch] text-ink-dim text-[1.05rem]" data-id="element-122">
            Cada cuenta que escalamos pasa por el mismo proceso depurado. Sin
            atajos, sin humo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-123">
          <div data-id="element-124">
            {steps.map((step, i) => <motion.div key={step.n} initial={{
            opacity: 0,
            y: 34
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-10%'
          }} transition={{
            duration: 0.8,
            ease: [0.2, 0.7, 0.2, 1],
            delay: i * 0.07
          }} className="py-[38px] border-t border-line grid grid-cols-[80px_1fr] gap-5 transition-all duration-350 hover:pl-[14px]" data-id="element-125">
                <div className="font-serif text-[2.6rem] text-acid leading-none" data-id="element-126">
                  {step.n}
                </div>
                <div data-id="element-127">
                  <h4 className="text-[1.3rem] font-bold mb-2 tracking-[-0.02em]" data-id="element-128">
                    {step.title}
                  </h4>
                  <p className="text-ink-dim text-[0.96rem]" data-id="element-129">{step.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 34
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-10%'
        }} transition={{
          duration: 0.8,
          ease: [0.2, 0.7, 0.2, 1],
          delay: 0.28
        }} className="bg-[linear-gradient(155deg,#11150f,#0c0f0b)] border border-line rounded-[22px] p-10 self-start sticky top-[110px]" data-id="element-130">
            <div className="text-[clamp(3rem,7vw,5rem)] font-extrabold tracking-[-0.04em] leading-[0.92] text-acid" data-id="element-131">
              14<span className="text-[0.45em]" data-id="element-132">días</span>
            </div>
            <div className="text-ink-dim mt-[14px] text-[1rem] max-w-[26ch]" data-id="element-133">
              es lo que tardamos de media en validar un ángulo ganador y empezar
              a escalar.
            </div>

            <div ref={barsRef} className="flex gap-2 items-end h-[80px] mt-[34px]" data-id="element-134">
              {barHeights.map((h, i) => <i key={i} className="flex-1 bg-[linear-gradient(var(--acid),var(--acid-deep))] rounded-t opacity-85 origin-bottom transition-all duration-900 ease-[cubic-bezier(0.2,0.8,0.2,1)]" style={{
              height: barsAnimated ? `${h}%` : '0%',
              transitionDelay: `${120 + i * 90}ms`
            }} data-id="element-135"></i>)}
            </div>
            <p className="text-ink-faint text-[0.78rem] mt-[18px] font-mono" data-id="element-136">
              RESULTADO ACUMULADO POR SEMANA
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}